<template>
  <div class="home">
    <div class="rowsTitle">
      <div class="row">
        Список гайдов
      </div>
      <div class="row" />
      <div class="row">
        Список слайдов
      </div>
    </div>
    <div class="rows">
      <div class="row">
        <myScroll>
          <draggable class="groups" :list="items" :group="{ name: 'banner', pull: 'clone', put: false }" :sort="false">
            <div class="item" v-for="(item, i) in items" :key="i">
              <div class="elem">
                {{ item.title }}
              </div>
            </div>
          </draggable>
        </myScroll>
      </div>
      <div class="row">
        <DoubleRightIcon class="arrow" />
      </div>
      <div class="row">
        <myScroll>
          <draggable class="groups" v-model="banner" v-bind="dragOptions" @start="drag = true" @end="drag = false">
            <transition-group type="transition" :name="!drag ? 'flip-list' : null">
              <div class="item" v-for="(item, i) in banner" :key="i">
                <div class="elem">
                  {{ i + 1 }}. {{ item.title }}
                  <div class="btn" @click="removeBanner(i)">
                    <TrashIcon class="icon" />
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
        </myScroll>
      </div>
    </div>
    <Loader v-if="loader" />
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import DoubleRightIcon from '@/assets/svg/double-right-icon.svg?inline'
import TrashIcon from '@/assets/svg/trash-icon.svg?inline'
import Loader from '@/components/Loader'

import { mapState, mapActions } from 'vuex'

export default {
  components: {
    draggable,
    DoubleRightIcon,
    TrashIcon,
    Loader
  },
  computed: {
    ...mapState('guides', [
      'loader'
    ]),
    dragOptions() {
      return {
        animation: 200,
        group: 'banner',
        disabled: false,
        ghostClass: 'ghost'
      };
    },
    items: {
      get () {
        return this.$store.state.guides.items;
      },
    },
    banner: {
      get () {
        return this.$store.state.guides.banner || [];
      },
      set (value) {
        this.$store.dispatch('guides/setBanner', value);
      }
    }
  },
  data () {
    return {
      drag: false
    }
  },
  methods: {
    ...mapActions('guides', [
      'setBanners',
      'setItems',
      'removeBanner'
    ])
  },
  async mounted () {
    this.setBanners()
  }
}
</script>

<style lang="scss" scoped>
.home{
  @include box(100%, 100%, relative, null, null, null, null, null, null);
  .rowsTitle{
    @include box(100%, 3.5vw, relative, null, null, null, null, null, #FFF);
    @include flex(left, top, row);
    .row{
      @include box(100%, 100%, relative, null, null, null, null, null, null);
      @include text(0.9vw, 500, 0.05vw, null, center, #333);
      @include flex(center, center, row);
      &:nth-child(1){
        @include size(48%, null);
        border-bottom: 0.04vw solid #DDD;
      }
      &:nth-child(2){
        @include size(4%, null);
        border-bottom: 0.04vw solid #FFF;
      }
      &:nth-child(3){
        @include size(48%, null);
        border-bottom: 0.04vw solid #DDD;
      }
    }
  }
  .rows{
    @include box(100%, calc(100% - 3.5vw), relative, null, null, null, null, null, null);
    @include flex(left, top, row);
    .row{
      @include box(50%, 100%, relative, null, null, null, null, null, null);
      user-select: none;
      &:nth-child(1){
        @include size(48%, null);
      }
      &:nth-child(2){
        @include box(4%, 100%, relative, null, null, null, null, null, #FFF);
        border-right: 0.04vw solid #DDD;
        border-left: 0.04vw solid #DDD;
        @include flex(center, center, row);
        .arrow{
          @include size(1.3vw, 1.3vw);
          fill: #999;
        }
      }
      &:nth-child(3){
        @include size(48%, null);
      }
      .groups{
        @include box(100%, 100%, relative, null, null, null, null, null, null);
        @include padding(0, 0, 0, 0);
        min-height: 20vw;
        span{
          width: 100%;
          display: block;
          min-height: 20vw;
        }
        .item{
          @include box(100%, auto, relative, null, null, null, null, null, null);
          @include padding(0, 0, 0, 0);
          .elem{
            @include box(100%, 3.5vw, relative, null, null, null, null, 0, #FFF);
            @include flex(left, center, row);
            @include padding(1.5vw, 0, 1vw, 0);
            @include border(0.04vw, solid, #DDD, null, null, null, null);
            @include text(0.9vw, 400, 0.04vw, null, center, #555);
            &:hover{
              @include box(null, null, null, null, null, null, null, null, #F8F8F8);
              cursor: pointer;
            }
            .btn{
              @include box(3.5vw, 100%, absolute, null, 0, 0, null, null, null);
              @include flex(center, center, row);
              transition: 0.3s;
              border-left: 0.04vw solid #DDD;
              .icon{
                @include box(1vw, 1vw, absolute, null, null, null, null, null, null);
                transition: 0.3s;
              }
              &:hover{
                width: 5vw;
                background-color: #FFF;
                .icon{
                  transform: scale(1.2);
                  path{
                    stroke: #f2564d;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .flip-list-move {
    transition: transform 0.5s;
  }
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }
  .no-move {
    transition: transform 0s;
  }
}
</style>
